import type React from 'react';
import { useTranslation } from 'react-i18next';
import { FaUserCheck as RespondentsIcon } from 'react-icons/fa';

import { numberOrDash } from 'src/helper/helper';
import Column from 'src/components/dashboard/DashboardPage/components/Column/index';

export interface RespondentsColumnProps {
  respondents: (number | null)[];
}
const RespondentsColumn: React.FC<RespondentsColumnProps> = ({
  respondents,
}) => {
  const { t } = useTranslation('dashboard');

  return (
    <Column
      header={
        <>
          <RespondentsIcon size={40} />
          {t('Labels.Respondents')}
        </>
      }
      data={respondents.map((responses) => numberOrDash(responses))}
    />
  );
};

export default RespondentsColumn;
